import * as React from 'react';
import { useState } from 'react';
import AuthGoogleAccessForm from '../accounts/AuthGoogleAccessForm';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import { Checkbox } from '../../../Shared';

interface LinkProviderAccountModalProps {
  close: () => void;
  link?: string;
  provider: string
  user: any;
}

const LinkProviderAccountModal = ({ link, close, provider, user }: LinkProviderAccountModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  const [termsAccepted, setTermsAccepted] = useState(false);

  const toggleCheckbox = () => { setTermsAccepted(!termsAccepted) }

  const renderLinkAccountButton = () => {
    const buttonText = 'Link Account'
    let buttonClass = 'quill-button contained green medium focus-on-light';

    if (termsAccepted) {
      if (provider === 'Google') { return <AuthGoogleAccessForm buttonClass={buttonClass} offlineAccess={true} showIcon={false} text={buttonText} /> }

      return <a className={buttonClass} href={link}>{buttonText}</a>
    } else {
      buttonClass += ' disabled';
      return <button className={buttonClass} type="button">{buttonText}</button>
    }
  }

  return (
    <div className="modal-container link-provider-account-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="linkProviderAccountModalTitle"
        aria-modal="true"
        className="link-provider-account-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="linkProviderAccountModalTitle">Link your account to {provider}</h3>
        </div>
        <p>Your email, {user.email}, is not associated with a {provider} account.</p>
        <Checkbox
          label={`I understand that I will now log in to Quill via the "Log in with ${provider}" button.`}
          onClick={toggleCheckbox}
          selected={termsAccepted}
        />
        <div className="form-buttons">
          <button
            className="quill-button outlined green medium focus-on-light"
            onClick={close}
            type="button"
          >
            Cancel
          </button>
          {renderLinkAccountButton()}
        </div>
      </div>
    </div>
  )
}

export default LinkProviderAccountModal;
